import React,{useState, useEffect} from 'react'
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import { API } from '../../../services/api';
import ImgLoading from '../../../assets/cargacaleta.gif';
import "./ProductList.scss";
import { useHistory } from 'react-router-dom';

export function ProductListPage() {
  /**
   * Vista de productos
   * Se consulta el listado de productos la servidor
   * se renderizan los productos en una tabla
   */
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }
  
  useEffect(() => {
    protectedRoute();
    setLoading(true);
    /**
     * Obtener los productos
     * Se hace el llamado al servicio /products/get-all-products
     */
    API.getAllProducts()
      .then(res => {
        setProducts(res);
        setLoading(false);
      })
      .catch(err => {
        setProducts([]);
        setLoading(false);
      })
  }, []);

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
    <HeaderAdmin/>
    <LateralMenu/>
    <main className="content">
        <h2>Productos</h2>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Región</th>
                <th>Descripción</th>
                <th>Usuario</th>
                <th>Fecha de creación</th>
              </tr>
            </thead>
            <tbody>
              {
                products.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.regionKey}</td>
                    <td>{item.description}</td>
                    <td>{`${item.userData.name} ${item.userData.lastname}`}</td>
                    <td>{new Date(item._createTimestamp).toLocaleDateString()}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </main>
    </>
  )
}
